
import { Loader } from "@shared/core/helpers/loaderHelper";
import { InvoiceService } from "@shared/core/services/invoiceService";
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class PublicInvoice extends Vue {
  data: any = null;
  isError: boolean = false;
  finished: boolean = false;
  invoiceService: InvoiceService = new InvoiceService();

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    Loader.Loading("inProgress");
    await this.invoiceService.downloadInvoicePdf(this.$route.params.token, this.handlePDFResponse);
  }

  private handlePDFResponse(ok: boolean, dataOrErrors: any) {
    this.finished = true;
    Loader.Unloading("inProgress");

    if (ok) return;

    this.handleErrors(dataOrErrors);
  }

  private handleErrors(dataOrErrors: any) {
    this.isError = true;
  }

}
